<template>
    <v-row no-gutters justify="start">
      <v-chip class="mx-1" outlined v-for="f in filterHelper" :key="f.value" @click="f.enabled = !f.enabled; toggleFilter(f.value)" :color="f.color">
        <v-avatar left>
            <v-icon v-text="f.enabled ? '$filterActive' : '$filterInactive'"></v-icon>
        </v-avatar>
        {{ f.title.toUpperCase() }}
      </v-chip>
    </v-row>
</template>
<script>
export default {
    name: 'CampaignsFilter',
    props: { filters: Array, value: String },
    data() {
        return {
            activeFilterInt: {},
            filterHelper:[]

        }
    },
    methods: {
        toggleFilter(value) {
            this.activeFilterInt[value] = !this.activeFilterInt[value];
            this.update();
        },
        isActive(value) {
            return this.activeFilterInt[value];
        },
        update() {
            this.$emit('input', `*${Object.keys(this.activeFilterInt).filter(k => this.activeFilterInt[k]).join('*')}*`);
        }
    },
    created() {
        this.filters.forEach((f) => { this.activeFilterInt[f.value] = f.enabled });
        this.filterHelper = JSON.parse(JSON.stringify(this.filters));
        this.update();
    }
}
</script>